import { createApiSaga } from "redux-store/api-sagas";
import { networkService } from "service/network";

import {
  CREATE_NETWORK,
  CREATE_NETWORK_SUCCESS,
  DELETE_NETWORK,
  DELETE_NETWORK_SUCCESS,
  EDIT_NETWORK,
  EDIT_NETWORK_FLAGS,
  EDIT_NETWORK_FLAGS_SUCCESS,
  EDIT_NETWORK_PARAMS,
  EDIT_NETWORK_PARAMS_SUCCESS,
  EDIT_NETWORK_SUCCESS,
  LOAD_NETWORK,
  LOAD_NETWORK_FAILURE,
  LOAD_NETWORK_SUCCESS,
  LOAD_NETWORKS,
  LOAD_NETWORKS_FAILURE,
} from "./actions";

const reloadNetworksSaga = createApiSaga({
  service: networkService.load,
  serviceName: "networkService.load",
  successAction: LOAD_NETWORKS,
  failureAction: LOAD_NETWORKS_FAILURE,
  reload: true,
});

const reloadAllNetworksSaga = createApiSaga({
  service: networkService.loadAll,
  serviceName: "networkService.loadAll",
  successAction: LOAD_NETWORKS,
  failureAction: LOAD_NETWORKS_FAILURE,
  reload: true,
});

const createNetworkSaga = createApiSaga({
  fetchAction: CREATE_NETWORK,
  reload: false,
  service: networkService.new,
  serviceName: "networkService.new",
  successAction: CREATE_NETWORK_SUCCESS,
});

const deleteNetworkSaga = createApiSaga({
  fetchAction: DELETE_NETWORK,
  reload: false,
  service: networkService.delete,
  serviceName: "networkService.delete",
  successAction: DELETE_NETWORK_SUCCESS,
});

const editFlagsSaga = createApiSaga({
  fetchAction: EDIT_NETWORK_FLAGS,
  reload: false,
  service: networkService.updateFlags,
  serviceName: "networkService.updateFlags",
  successAction: EDIT_NETWORK_FLAGS_SUCCESS,
});

const editParamsSaga = createApiSaga({
  fetchAction: EDIT_NETWORK_PARAMS,
  reload: false,
  service: networkService.updateParams,
  serviceName: "networkService.updateParams",
  successAction: EDIT_NETWORK_PARAMS_SUCCESS,
});

const editDetailsSaga = createApiSaga({
  fetchAction: EDIT_NETWORK,
  reload: false,
  service: networkService.updateDetails,
  serviceName: "networkService.updateDetails",
  successAction: EDIT_NETWORK_SUCCESS,
});

const getNetworkSaga = createApiSaga({
  service: networkService.get,
  serviceName: "networkService.get",
  fetchAction: LOAD_NETWORK,
  failureAction: LOAD_NETWORK_FAILURE,
  successAction: LOAD_NETWORK_SUCCESS,
});

const networkSagas = [
  createNetworkSaga(),
  deleteNetworkSaga(),
  editDetailsSaga(),
  editFlagsSaga(),
  editParamsSaga(),
  getNetworkSaga(),
];

export { networkSagas, reloadNetworksSaga, reloadAllNetworksSaga };
